import PropTypes from 'prop-types'
import React, {useContext, useLayoutEffect, useState} from 'react';
import {useHttp} from "../../hooks/http.hook";
import {AuthContext} from "../../context/AuthContext";
import DaDataModal2 from "./DaDataModal2";

EditOrgWithDaData.propTypes = {
    id: PropTypes.string,
    closeHandler: PropTypes.func,
    url: PropTypes.string
}


function EditOrgWithDaData(props) {
    const {request} = useHttp()
    const baseURl = process.env.REACT_APP_BASE_URL
    const {token} = useContext(AuthContext)
    const [data, setData] = useState();

    const getOrganizationById = async () => {
        var url = `${baseURl}/api/v2/general/organizations/${props.id}`
        const {data, status} = await request(url, 'GET', null, {Authorization: `Bearer ${token.token}`})
        if (status >= 200 && status < 300) {
            setData(data.data)
        }
    }

    useLayoutEffect(() => {
        getOrganizationById()
    }, []);


    return (
        <DaDataModal2 closeHandler={props.closeHandler} data={data} url={props.url?props.url:`/api/v2/general/organizations/${props.id}`}/>
    );
}

export default EditOrgWithDaData;